// extracted by mini-css-extract-plugin
export default {"wrap":"wrap--lMirb","col":"col--lMirb"};